import { render } from "./registerView.vue?vue&type=template&id=12342a74"
import script from "./registerView.vue?vue&type=script&lang=js"
export * from "./registerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__